import React from 'react';
import { useTranslation } from 'react-i18next';
import { BuildingLinkCode } from 'shared/models';
import { BuildingLinkCodesListItem } from '../buildingLinkCodesListItem/BuildingLinkCodesListItem';

require('./BuildingLinkCodesList.css');

export type Props = {
    linkCodes: BuildingLinkCode[];
    loading: boolean;
    onClickDelete(linkCode: string): void;
};

export const BuildingLinkCodesList = ({ linkCodes, loading, onClickDelete }: Props) => {
    const { t } = useTranslation();

    return (
        <div className="building-link-codes-list">
            <table className="ui single line compact table">
                <colgroup>
                    <col style={ { width: '80%' } }/>
                    <col style={ { width: '20%' } }/>
                </colgroup>
                <thead>
                    <tr>
                        <th>{ t('BUILDING.ORGS.LABEL.LINK_CODE') }</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    { loading && linkCodes.length === 0 &&
                        <tr>
                            <td colSpan={ 2 }>
                                <i className="spinner loading icon"/>
                                <span>
                                    { t('LOADING') }
                                </span>
                            </td>
                        </tr>
                    }
                    { linkCodes.map(lc =>
                        <BuildingLinkCodesListItem
                            key={ lc.linkCode }
                            linkCode={ lc }
                            onClickDelete={ () => onClickDelete(lc.linkCode) }
                        />
                    ) }
                </tbody>
            </table>
        </div>
    );
};
